import { Apartment, ApartmentStatus, Status } from '../types/apartments'
import { ApplicationStatus } from '../types/applications'

const getApartmentStatusInfo = (
  { status }: Apartment,
  inNewApplications: boolean,
  hasMedia: boolean | undefined
) => {
  if (status === 'marketing' && inNewApplications) {
    return {
      statusTranslation: 'newApplicants',
      statusColor: '#E2EBFD'
    }
  } else if (status === 'marketing') {
    return {
      statusTranslation: 'setMarketing',
      statusColor: '#E2EBFD'
    }
  } else if (hasMedia && status === ApartmentStatus.confirmed) {
    return {
      statusTranslation: 'inProcessing',
      statusColor: '#E2EBFD'
    }
  } else if (status === ApartmentStatus.followUp) {
    return {
      statusTranslation: 'followUp',
      statusColor: '#E2EBFD'
    }
  } else if (status === ApartmentStatus.rentContractWanted) {
    return {
      statusTranslation: 'inProcessingForRenting',
      statusColor: '#E2EBFD'
    }
  } else if (!hasMedia && status === ApartmentStatus.confirmed) {
    return {
      statusTranslation: 'missingMedia',
      statusColor: '#E2EBFD'
    }
  } else if (status === ApartmentStatus.created) {
    return {
      statusTranslation: 'missingImportantInformation',
      statusColor: '#E2EBFD'
    }
  } else if (status === ApartmentStatus.rented) {
    return {
      statusTranslation: 'rented',
      statusColor: '#E2EBFD'
    }
  } else if (status === ApartmentStatus.cancelled) {
    return {
      statusTranslation: 'cancelled',
      statusColor: '#E2EBFD'
    }
  } else {
    return {
      statusTranslation: 'failed',
      statusColor: '#E2EBFD'
    }
  }
}

const getApplicationStatus = (status: string) => {
  if (status === ApplicationStatus.created) {
    return 'created'
  } else if (status === ApplicationStatus.rejected) {
    return 'rejected'
  } else if (status === ApplicationStatus.notInterested) {
    return 'notInterested'
  } else if (status === ApplicationStatus.accepted) {
    return 'accepted'
  } else if (status === ApplicationStatus.noAvailableTimes) {
    return 'noAvailableTimes'
  } else if (status === ApplicationStatus.manual) {
    return 'manual'
  } else if (status === ApplicationStatus.showingReserved) {
    return 'showingReserved'
  } else if (status === ApplicationStatus.wantsContract) {
    return 'wantsContract'
  } else if (status === ApplicationStatus.invitationsSent) {
    return 'invitationsSent'
  } else if (status === ApplicationStatus.tenant) {
    return 'tenant'
  } else {
    return 'error'
  }
}

/**
 * Normal apartment status changing order
 * 1. created
 * 2. confirmed
 * 3. marketing
 * 4. rentContractWanted
 * 5. rented
 * Note: there are exceptions and apartment can be always
 * changed to cancelled status if landlord cancels the order
 */

/**
 * Marketing is disabled if apartment is already in marketing or it is created (not confirmed)
 * or wants rent contract
 */
const isApartmentMarketingDisabled = (currentStatus: Status) =>
  currentStatus === ApartmentStatus.created ||
  currentStatus === ApartmentStatus.marketing

const isApartmentRentContractWantedDisabled = (currentStatus: Status) =>
  currentStatus === ApartmentStatus.created ||
  currentStatus === ApartmentStatus.confirmed ||
  currentStatus === ApartmentStatus.rentContractWanted ||
  currentStatus === ApartmentStatus.rented

const isApartmentRentedDisabled = (
  currentStatus: Status,
  selectedContractWantedName: string | undefined
) =>
  currentStatus !== ApartmentStatus.rentContractWanted ||
  !selectedContractWantedName

const isApartmentCancelledDisabled = (currentStatus: Status) =>
  currentStatus === ApartmentStatus.cancelled

export {
  getApartmentStatusInfo,
  getApplicationStatus,
  isApartmentMarketingDisabled,
  isApartmentRentContractWantedDisabled,
  isApartmentRentedDisabled,
  isApartmentCancelledDisabled
}
